<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

import Button from 'dashboard/components-next/button/Button.vue';
import ConfirmContactDeleteDialog from 'dashboard/components-next/Contacts/ContactsForm/ConfirmContactDeleteDialog.vue';

defineProps({
  selectedContact: {
    type: Object,
    required: true,
  },
});

const { t } = useI18n();

const confirmDeleteContactDialogRef = ref(null);

const openConfirmDeleteContactDialog = () => {
  confirmDeleteContactDialogRef.value?.dialogRef.open();
};
</script>

<template>
  <div class="flex flex-col items-start gap-3 border-t border-n-strong px-6 py-5">
    <div class="flex flex-col gap-1">
      <h6 class="text-sm font-medium text-n-slate-12 m-0">
        {{ t('CONTACTS_LAYOUT.DETAILS.DELETE_CONTACT') }}
      </h6>
      <span class="text-sm text-n-slate-11">
        {{ t('CONTACTS_LAYOUT.CARD.DELETE_CONTACT.MESSAGE') }}
      </span>
    </div>
    <Button
      :label="t('CONTACTS_LAYOUT.CARD.DELETE_CONTACT.BUTTON')"
      size="sm"
      color="ruby"
      @click="openConfirmDeleteContactDialog()"
    />
    <ConfirmContactDeleteDialog
      ref="confirmDeleteContactDialogRef"
      :selected-contact="selectedContact"
    />
  </div>
</template>
